import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    d1MenuSwitch: false,
    beforeEnterText: null,
    firstEnterWebSite: true,
    productMixInfo: [],
    mobileAboutDetailOnShow: false,
  },
  mutations: {
    SET_PMI(state, data) {
      state.productMixInfo = data;
    },
    OPEN_MENU(state) {
      state.d1MenuSwitch = true;
    },
    CLOSE_MENU(state) {
      state.d1MenuSwitch = false;
    },
    SET_ENTER_ROUTER(state, val) {
      state.beforeEnterText = val;
    },
    SIGN_ENTERED(state) {
      state.firstEnterWebSite = false;
    },
  },
  actions: {
  },
  modules: {
  },
});
